import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiPost, operationsClient } from '@/lib/api';
import { opsEstimateEndpoints } from '@/lib/api/endpoints';
import { estimateKeys } from '@/lib/queryKeys';

interface ConvertToInvoiceResult {
  job: { id: string };
  invoiceId: string;
}

/**
 * Converts an approved estimate to a job + draft invoice in one shot.
 * Navigates to the new invoice on success.
 */
export function useConvertToInvoice() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useApiMutation<ConvertToInvoiceResult, string>({
    mutationFn: (id) =>
      apiPost<ConvertToInvoiceResult>(operationsClient, opsEstimateEndpoints.convertToJob(id), {
        createInvoice: true,
      }),
    onSuccess: (data, id) => {
      void queryClient.invalidateQueries({ queryKey: estimateKeys.lists() });
      void queryClient.invalidateQueries({ queryKey: estimateKeys.detail(id) });
      toast.success('Invoice created');
      // @ts-expect-error — search required by TanStack Router v1.168
      void navigate({ to: '/dashboard/invoices/$id', params: { id: data.invoiceId } });
    },
  });
}
